/**
 * Cart Services Upsell (Yeppon) — "seconda occasione"
 * Per ogni prodotto in carrello SENZA servizi (placeholder [data-svc-upsell]),
 * chiama il proxy della scheda (product_shipping_info_box). Se il prodotto ha
 * servizi (elettrodomestico), mostra i bottoni Aggiungi coi prezzi esatti.
 * Il click aggiunge la variante servizio con _svc_price (prezzata dalla Function).
 *
 * Il riquadro usa lo stesso guscio della garanzia nel carrello (bordo, fondo,
 * raggio, pulsante verde): stessa larghezza, in pagina e nel cassetto.
 */
(function () {
  'use strict';
  if (window.__ypSvcUpsellLoaded) return;
  window.__ypSvcUpsellLoaded = true;
  if (window.ypNoUpsell) return; // landing partner: niente upsell (snippets/upsell-off.liquid)

  var SERVICE_VARIANTS = {
    INST: '65719443194205',
    RAEE: '65719443226973',
    GPO: '65719443259741',
    INC: '65773405274461',
    KC: '65783243342173'
  };
  // i servizi presuppongono la consegna al piano: se manca, la riga-marcatore
  // ALP (0,00 - "Inclusa nella spedizione") viene aggiunta insieme al servizio
  var ALP_MARKER_VARIANT = '65719443161437';
  // zona scelta in scheda (fase 2 CAP): riusata qui per la nota trasparenza costi
  function getCap() {
    try {
      var z = localStorage.getItem('yp_svc_cap') || '';
      return /^\d{5}$/.test(z) && z !== '00000' ? z : '';
    } catch (e) { return ''; }
  }
  var ALP_SHIPPING_ID = 39;
  function codeForName(name) {
    var n = (name || '').toLowerCase();
    // "colonna" PRIMA di "installazione": "Installazione a colonna" contiene entrambe
    if (n.indexOf('colonna') !== -1) return 'KC';
    if (n.indexOf('installazione') !== -1) return 'INST';
    if (n.indexOf('ritiro') !== -1) return 'RAEE';
    if (n.indexOf('inversione') !== -1) return 'GPO';
    if (n.indexOf('incasso') !== -1) return 'INC';
    return null;
  }
  function parseEuro(text) {
    if (!text) return null;
    if (/gratis/i.test(text)) return 0;
    var m = text.replace(/\s/g, '').match(/([\d.]*\d(?:,\d{1,2})?)/);
    if (!m) return null;
    var n = parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }
  // Come la riga prodotto e la garanzia: FoxTheme.Currency.formatMoney +
  // shop.money_format. Niente "+" davanti. "Gratis" resta solo a prezzo 0.
  function formatShopMoney(euros) {
    var n = parseFloat(euros);
    if (isNaN(n)) return '';
    var cents = Math.round(n * 100);
    var theme = window.FoxTheme;
    var format = (theme && theme.settings && theme.settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    try {
      if (theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(cents, format);
      }
    } catch (e) {}
    var neg = cents < 0;
    var abs = Math.abs(cents);
    var whole = String(Math.floor(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var frac = ('0' + (abs % 100)).slice(-2);
    return (neg ? '-' : '') + '€' + whole + ',' + frac;
  }
  function fmtEuro(n) { return n === 0 ? 'Gratis' : formatShopMoney(n); }
  function clean(t) { return (t || '').replace(/\s+/g, ' ').replace(/\*+/g, '').trim(); }

  function parseAddons(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var addons = [];
    // prezzo consegna al piano (primo h5): serve per la nota trasparenza costi
    var alpPrice = null;
    var h5 = doc.querySelector('h5');
    if (h5 && /al piano/i.test(h5.textContent || '')) {
      var sp = h5.querySelectorAll('span');
      alpPrice = parseEuro(sp[1] ? sp[1].textContent : '');
    }
    parseAddons.lastAlpPrice = alpPrice;
    var lis = doc.querySelectorAll('ul li');
    Array.prototype.forEach.call(lis, function (li) {
      var raw = li.textContent || '';
      var price = null;
      var pm = raw.match(/\(\s*\+?\s*€\s*[\d.,]+\s*\)/);
      if (pm) price = parseEuro(pm[0]);
      else if (/\(\s*gratis\s*\)/i.test(raw)) price = 0;
      if (price === null) return;
      var base = raw.replace(/\(\s*\+?\s*€\s*[\d.,]+\s*\)/i, '').replace(/\(\s*gratis\s*\)/i, '');
      var name = clean(base.split('(')[0]);
      var code = codeForName(name);
      if (code && SERVICE_VARIANTS[code]) addons.push({ name: name, price: price, code: code });
    });
    return addons;
  }

  // Stessi colori della garanzia (warranty-upsell.liquid → settings).
  function accenti() {
    var s = (window.__warrantyConfig && window.__warrantyConfig.settings) || {};
    return {
      color: s.accent_color || '#0b5d1e',
      end: s.accent_end || '#148a32'
    };
  }

  function injectStyles() {
    if (document.getElementById('yp-svc-style')) return;
    var a = accenti();
    var css = ''
      + '.yp-svc{position:relative;box-sizing:border-box;width:100%;max-width:100%;margin:10px 0;padding:8px 10px 8px 14px;'
      + 'background:linear-gradient(135deg,' + a.color + '08,' + a.color + '03);'
      + 'border:1px solid ' + a.color + '33;border-radius:10px;overflow:hidden;}'
      + '.yp-svc::before{content:"";position:absolute;top:0;left:0;width:3px;height:100%;'
      + 'background:linear-gradient(180deg,' + a.color + ',' + a.end + ');}'
      + '.yp-svc__title{margin:0 0 8px;font-size:13.5px;font-weight:700;color:#1a1a1a;line-height:1.3;}'
      + '.yp-svc__list{display:flex;flex-direction:column;gap:8px;}'
      + '.yp-svc__row{display:flex;align-items:center;gap:8px 10px;min-width:0;}'
      + '.yp-svc__name{flex:1 1 auto;min-width:0;font-size:13px;font-weight:600;color:#1a1a1a;line-height:1.3;}'
      + '.yp-svc__price{flex:0 0 auto;font-size:14px;font-weight:800;color:' + a.color + ';white-space:nowrap;line-height:1;}'
      + '.yp-svc__btn{flex:0 0 auto;margin:0;min-height:0;height:32px;padding:0 14px;display:inline-flex;align-items:center;justify-content:center;'
      + 'background:linear-gradient(135deg,' + a.color + ',' + a.end + ');color:#fff;border:none;border-radius:8px;'
      + 'font-size:12px;font-weight:700;line-height:1;letter-spacing:0;text-transform:none;white-space:nowrap;cursor:pointer;'
      + 'box-shadow:0 2px 10px ' + a.color + '33;}'
      + '.yp-svc__btn:hover:not(:disabled){transform:translateY(-1px);box-shadow:0 4px 14px ' + a.color + '55;filter:brightness(1.05);}'
      + '.yp-svc__btn:disabled{opacity:.65;cursor:wait;}'
      + '.yp-svc__btn:focus-visible{outline:3px solid #0066cc;outline-offset:2px;}'
      + '.yp-svc.yp-svc--largo{padding-left:50px;padding-right:46px;}'
      + '.yp-svc__note{margin:8px 0 0;font-size:12px;line-height:1.35;color:#555;}'
      + '.yp-svc__error{margin-top:8px;font-size:12px;line-height:1.45;color:#b3261e;}'
      + '.cart tbody tr.cart-item--service-upsell{border:0;}'
      + '.cart tbody tr.cart-item--service-upsell:last-child{border-block-end:0.1rem solid rgba(var(--color-border),var(--color-border-alpha,1));}'
      + '.cart tbody tr.cart-item--service-upsell > td{padding:0;border:0;}'
      + '.cart tbody tr.cart-item:has(+ .cart-item--service-upsell:not([hidden])) > td{padding-bottom:0;}'
      + '.wuc-row + .cart-item--service-upsell .yp-svc,'
      + '.wuc-banner + .cart-item--service-upsell .yp-svc{margin-top:0;}'
      + 'cart-drawer .cart-item--service-upsell,.cart-drawer .cart-item--service-upsell,.drawer--cart .cart-item--service-upsell{list-style:none;margin:calc(10px - 2.4rem) 0 0;padding:0;}'
      + '@media (max-width:767.98px){.yp-svc{margin-left:0 !important;width:100% !important;max-width:100% !important;}}'
      + 'cart-drawer .yp-svc,.cart-drawer .yp-svc,.drawer--cart .yp-svc{margin:0 !important;width:100% !important;max-width:100% !important;}'
      // Nel cassetto la garanzia non e' "larga": il titolo parte dopo bordo,
      // padding 14px, scudo 22px e gap 10px (46px di contenuto). Senza questo
      // rientro "Vuoi aggiungere un servizio?" resta 32px piu' a sinistra.
      // Se la card diventa larga il gap della garanzia passa a 14px.
      + 'cart-drawer .yp-svc:not(.yp-svc--largo),.drawer--cart .yp-svc:not(.yp-svc--largo){padding-left:46px;}'
      + 'cart-drawer .yp-svc.yp-svc--largo,.drawer--cart .yp-svc.yp-svc--largo{padding-left:50px;padding-right:46px;}'
      // Su /cart da telefono la card non e' "larga": il titolo della garanzia
      // parte dopo bordo, padding 14px, scudo 22px e gap 10px. Stesso rientro
      // del cassetto. Da computer resta .yp-svc--largo.
      + '@media (max-width:767.98px){.cart .yp-svc:not(.yp-svc--largo){padding-left:46px;}}';
    var style = document.createElement('style');
    style.id = 'yp-svc-style';
    style.textContent = css;
    document.head.appendChild(style);
  }
  injectStyles();

  // Stessa soglia e stesso breakpoint di warranty-upsell-cart.js (allinea).
  var MIN_COLONNA = 280;
  var MQ_MOBILE = window.matchMedia('(max-width: 767.98px)');

  function inDrawer(row) {
    return !!(row.closest && row.closest('cart-drawer, .cart-drawer, .drawer--cart'));
  }
  function productLine(row) {
    var el = row.previousElementSibling;
    while (el) {
      if (el.classList && el.classList.contains('cart-item') &&
          !el.classList.contains('cart-item--service') &&
          !el.classList.contains('cart-item--service-upsell')) return el;
      el = el.previousElementSibling;
    }
    return null;
  }
  function nearestBanner(row) {
    var el = row.previousElementSibling;
    while (el) {
      if (el.classList && el.classList.contains('wuc-row')) {
        var inner = el.querySelector('.wuc-banner');
        if (inner) return inner;
      }
      if (el.classList && el.classList.contains('wuc-banner')) return el;
      if (el.classList && el.classList.contains('cart-item') &&
          !el.classList.contains('cart-item--service') &&
          !el.classList.contains('cart-item--service-upsell')) return null;
      el = el.previousElementSibling;
    }
    return null;
  }

  function alignSvc(row) {
    var box = row.querySelector('[data-svc-upsell-box]');
    if (!box) return;
    function calcola() {
      if (!box.isConnected) return;
      try {
      if (MQ_MOBILE.matches || inDrawer(row)) {
        box.style.marginLeft = '';
        box.style.width = '';
        return;
      }
      var hostEl = box.parentElement;
      if (!hostEl) return;
      var host = hostEl.getBoundingClientRect();
      if (!host.width) return;
      var banner = nearestBanner(row);
      if (banner && row.__ypSvcRO && !banner.__ypSvcObserved) {
        try { row.__ypSvcRO.observe(banner); banner.__ypSvcObserved = true; } catch (e) {}
      }
      var br = banner && banner.getBoundingClientRect();
      if (br && br.width >= 80) {
        var left = Math.max(0, Math.round(br.left - host.left));
        var width = Math.round(br.width);
        if (left + width <= host.width + 1) {
          box.style.marginLeft = left + 'px';
          box.style.width = width + 'px';
          return;
        }
      }
      var line = productLine(row);
      if (!line) return;
      var lr = line.getBoundingClientRect();
      if (!lr.width) return;
      var info = line.querySelector('.cart-item__product--info, .cart-item__details, .cart-item__info');
      var media = line.querySelector('.cart-item__media');
      var x = info ? info.getBoundingClientRect().left : (media ? media.getBoundingClientRect().right + 12 : lr.left);
      var spostamento = Math.max(0, Math.round(x - host.left));
      var available = host.width - spostamento;
      if (spostamento && available >= MIN_COLONNA) {
        box.style.marginLeft = spostamento + 'px';
        box.style.width = 'calc(100% - ' + spostamento + 'px)';
      } else {
        box.style.marginLeft = '';
        box.style.width = '';
      }
      } finally {
        if (box.isConnected) box.classList.toggle('yp-svc--largo', box.getBoundingClientRect().width >= 460);
      }
    }
    calcola();
    if (row.__ypSvcAlign) return;
    row.__ypSvcAlign = true;
    if (window.ResizeObserver) {
      try {
        var ro = new ResizeObserver(calcola);
        row.__ypSvcRO = ro;
        var line = productLine(row);
        if (line) ro.observe(line);
        if (box.parentElement) ro.observe(box.parentElement);
        var bannerNow = nearestBanner(row);
        if (bannerNow && !bannerNow.__ypSvcObserved) {
          ro.observe(bannerNow);
          bannerNow.__ypSvcObserved = true;
        }
      } catch (e) {}
    }
    if (MQ_MOBILE.addEventListener) MQ_MOBILE.addEventListener('change', calcola);
    var parent = row.parentElement;
    if (parent && window.MutationObserver) {
      new MutationObserver(calcola).observe(parent, { childList: true });
    }
  }

  function onCartPage() {
    return /(^|\/)cart\/?$/.test(window.location.pathname);
  }
  function idSezioniCarrello() {
    var ft = window.FoxTheme, ids = [];
    if (!ft || !ft.utils || typeof ft.utils.getSectionId !== 'function') return ids;
    Array.prototype.forEach.call(document.querySelectorAll('cart-items'), function (el) {
      try {
        var id = ft.utils.getSectionId(el);
        if (id && ids.indexOf(id) < 0) ids.push(id);
      } catch (e) {}
    });
    return ids;
  }
  function urlConSezioni(ids) {
    var u = new URL(window.location.href);
    u.searchParams.set('sections', ids.join(','));
    return u.toString();
  }
  // Dopo cart/add.js: le sezioni carrello si ridisegnano da cartUpdate, come
  // la garanzia. Il cassetto, se era aperto, resta aperto. Su /cart non si
  // cambia pagina.
  function ridisegnaCarrello() {
    var ft = window.FoxTheme;
    var drawer = document.querySelector('cart-drawer');
    var eraAperto = !!(drawer && drawer.hasAttribute('open'));
    var ids = idSezioniCarrello();
    var cartUrl = (ft && ft.routes && ft.routes.cart_url) || '/cart.js';
    function riapri() {
      if (!eraAperto) return;
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.show === 'function' && !d.hasAttribute('open')) d.show();
    }
    var sectionsPromise = ids.length
      ? fetch(urlConSezioni(ids), { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      : Promise.resolve(null);
    return Promise.all([
      fetch(cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      sectionsPromise
    ]).then(function (res) {
      var cartJson = res[0] || {};
      if (res[1]) cartJson.sections = res[1];
      if (cartJson.sections && ft && ft.pubsub && ft.pubsub.publish && ft.pubsub.PUB_SUB_EVENTS) {
        ft.pubsub.publish(ft.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        riapri();
        return;
      }
      var sid = drawer && (drawer.getAttribute('data-section-id') || (ft && ft.utils && ft.utils.getSectionId && ft.utils.getSectionId(drawer)));
      if (sid) {
        return fetch('/?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            var html = sections && sections[sid];
            var host = document.getElementById('shopify-section-' + sid);
            if (html && host) host.innerHTML = html;
            riapri();
          });
      }
      if (onCartPage()) window.location.reload();
    });
  }

  function build(row, addons, parentGid, alpPrice, hasAlp) {
    var box = row.querySelector('[data-svc-upsell-box]');
    if (!box || box.getAttribute('data-built') === '1') return;
    box.setAttribute('data-built', '1');
    box.classList.add('yp-svc');
    box.textContent = '';

    var head = document.createElement('div');
    head.className = 'yp-svc__title';
    head.textContent = 'Vuoi aggiungere un servizio?';
    box.appendChild(head);

    var list = document.createElement('div');
    list.className = 'yp-svc__list';
    var errore = document.createElement('div');
    errore.className = 'yp-svc__error';
    errore.setAttribute('role', 'alert');
    errore.hidden = true;

    addons.forEach(function (a) {
      var line = document.createElement('div');
      line.className = 'yp-svc__row';
      var name = document.createElement('span');
      name.className = 'yp-svc__name';
      name.textContent = a.name;
      var priceText = fmtEuro(a.price);
      var price = document.createElement('span');
      price.className = 'yp-svc__price';
      price.textContent = priceText;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'yp-svc__btn';
      b.textContent = 'Aggiungi';
      var etichetta = a.name + ' · ' + priceText;
      b.setAttribute('aria-label', 'Aggiungi ' + etichetta);
      b.addEventListener('click', function () {
        b.disabled = true;
        b.textContent = 'Aggiungo…';
        errore.hidden = true;
        // quantita' del padre: il servizio nasce gia' allineato (niente doppio reload della sync)
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var qty = 0, hasAlpNow = false;
            cart.items.forEach(function (i) {
              var isSvc = i.properties && i.properties._parent;
              if (!isSvc && ('gid://shopify/Product/' + i.product_id) === parentGid) qty += i.quantity;
              if (isSvc && i.properties._parent === parentGid && i.properties._svc_code === 'ALP') hasAlpNow = true;
            });
            if (qty < 1) qty = 1;
            var items = [{ id: SERVICE_VARIANTS[a.code], quantity: qty, properties: { _svc_price: a.price.toFixed(2), _svc_code: a.code, _svc_label: a.name, _parent: parentGid } }];
            if (!hasAlpNow) {
              items.unshift({ id: ALP_MARKER_VARIANT, quantity: qty, properties: { _svc_price: '0.00', _svc_code: 'ALP', _svc_label: 'Consegna al piano e disimballo', _parent: parentGid } });
            }
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });
          })
          // Niente reload: nel cassetto chiuderebbe il drawer e riporterebbe
          // alla pagina sotto. Stesso aggiornamento della garanzia
          // (cartUpdate con l'HTML delle sezioni). Su /cart si ridisegna la
          // sezione, senza redirect.
          .then(function (r) {
            if (r.ok) return ridisegnaCarrello();
            return r.json().catch(function () { return {}; }).then(function (d) {
              throw new Error((d && (d.description || d.message)) || '');
            });
          })
          .catch(function (err) {
            b.disabled = false;
            b.textContent = 'Aggiungi';
            errore.textContent = 'Non è stato possibile aggiungere il servizio' +
              (err && err.message ? ': ' + err.message : '. Riprova tra poco.');
            errore.hidden = false;
          });
      });
      line.appendChild(name);
      line.appendChild(price);
      line.appendChild(b);
      list.appendChild(line);
    });
    box.appendChild(list);
    box.appendChild(errore);
    if (!hasAlp && alpPrice != null && alpPrice > 0) {
      var note = document.createElement('div');
      note.className = 'yp-svc__note';
      var cap = getCap();
      note.textContent = 'I servizi includono la Consegna al piano: al checkout la spedizione sarà "Consegna con servizio al piano" (' +
        fmtEuro(alpPrice) + (cap ? ' per il CAP ' + cap : ' indicativi') + ').';
      box.appendChild(note);
    }
    row.removeAttribute('hidden');
    alignSvc(row);
  }

  function scan() {
    var rows = document.querySelectorAll('[data-svc-upsell]');
    var pending = [];
    Array.prototype.forEach.call(rows, function (row) {
      var state = row.getAttribute('data-svc-state');
      if (state === 'loading' || state === 'ready' || state === 'empty') return;
      var apiUrl = (row.getAttribute('data-api-url') || '').replace(/\/$/, '');
      var parentGid = row.getAttribute('data-parent-gid');
      if (!apiUrl || !parentGid) return;
      row.setAttribute('data-svc-state', 'loading');
      pending.push(row);
    });
    if (!pending.length) return;
    // servizi gia' in carrello per prodotto padre: quelli non vanno riproposti
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var have = {};
        cart.items.forEach(function (i) {
          var p = i.properties && i.properties._parent;
          var code = i.properties && i.properties._svc_code;
          if (p && code) have[p + '|' + code] = true;
        });
        pending.forEach(function (row) {
          if (!row.isConnected) return;
          var apiUrl = (row.getAttribute('data-api-url') || '').replace(/\/$/, '');
          var parentGid = row.getAttribute('data-parent-gid');
          var cap = getCap();
          var endpoint = apiUrl + '?type=' + encodeURIComponent('product_shipping_info_box') +
            '&product_id=' + encodeURIComponent(parentGid) + '&logged_in_customer_id=' +
            (cap ? '&zipCode=' + encodeURIComponent(cap) : '');
          fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (!row.isConnected) return;
              if (!d || !d.html) { row.setAttribute('data-svc-state', 'empty'); return; }
              var addons = parseAddons(d.html).filter(function (a) {
                if (have[parentGid + '|' + a.code]) return false;
                // KC solo se l'installazione classica e' gia' in carrello per questo prodotto
                if (a.code === 'KC' && !have[parentGid + '|INST']) return false;
                return true;
              });
              // prezzo al piano: campi strutturati (id 39) con fallback al parsing html
              var alpPrice = parseAddons.lastAlpPrice;
              if (d.shippingList && d.shippingList.length) {
                d.shippingList.forEach(function (o) { if (o.id === ALP_SHIPPING_ID) alpPrice = o.price; });
              }
              if (addons.length) {
                build(row, addons, parentGid, alpPrice, !!have[parentGid + '|ALP']);
                row.setAttribute('data-svc-state', 'ready');
              } else {
                row.setAttribute('data-svc-state', 'empty');
              }
            })
            .catch(function () { if (row.isConnected) row.removeAttribute('data-svc-state'); });
        });
      })
      .catch(function () {
        pending.forEach(function (row) { if (row.isConnected) row.removeAttribute('data-svc-state'); });
      });
  }

  function watchNewRows() {
    if (!window.MutationObserver || document.documentElement.__ypSvcWatch) return;
    document.documentElement.__ypSvcWatch = true;
    var timer;
    new MutationObserver(function (mutations) {
      var found = false;
      for (var i = 0; i < mutations.length && !found; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches('[data-svc-upsell]')) || (n.querySelector && n.querySelector('[data-svc-upsell]'))) {
            found = true;
            break;
          }
        }
      }
      if (!found) return;
      clearTimeout(timer);
      timer = setTimeout(scan, 40);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function start() {
    scan();
    watchNewRows();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
